import Sprite from "./Sprite";

export default class TileDamageSpriteSeries {
    /**
     * 
     * @param {Sprite[]} sprites 
     */
    constructor(sprites) {
        /**
         * @private
         * @constant
         * @type {Sprite[]}
         */
        this.sprites = sprites;

        /**
         * @private
         * @constant
         * @type {number}
         */
        this.step = 100 / sprites.length;
    }

    /**
     * @param {number} healthPercent
     * @returns {Sprite}
     */
    getDamageSprite(healthPercent) {
        // if (healthPercent <= 0 || healthPercent >= 100) {
        //     return null;
        // }

        if (healthPercent >= 100) {
            return null;
        }

        const idx = (this.sprites.length - 1) - (healthPercent / this.step) | 0;
        if (idx >= this.sprites.length || idx < 0) {
            console.log('getDamageSprite() bad index calculated. healthPercent=' + healthPercent + ' idx=' + idx);
            return null;
        }

        return this.sprites[idx];

        ////console.log('health=' + healthPercent + ' idx=' + idx);

        /////////////////////////////////////

        // let currStep = this.step;
        // let index = 0;

        // const damagePercent = 100 - healthPercent;

        // do {
        //     if (damagePercent < currStep) {
        //         return this.sprites[index];
        //     }
        //     index++;
        //     currStep += this.step;
        // }
        // while (index < this.sprites.length);

        // console.log('TileDamageSpriteSeries.getDamageSprite() failed to find sprite. healthPercent=' + healthPercent + '. sprites.length=' + this.sprites.length);
 
        // return null;
    }
}